import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import autoBind from "react-autobind";
import { Table } from "react-bootstrap";
import Card from "@common/externos/components/card/card.externo";
import validacaoSolicitacaoActions from "../store/validacaoSolicitacao.actions";
import validacaoSolicitacaoSelector from "../store/validacaoSolicitacao.selectors";
import { connect } from "@common/components/base.component";

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  onClose() {
    this.props.validacaoSolicitacaoActions.closeModal();
  }

  render() {
    const { validacaoSolicitacao } = this.props.validacaoSolicitacaoSelector;

    return (
      <Modal show={validacaoSolicitacao.show} onHide={this.onClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Validação da Solicitação</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Card>
            <h4 className={"mb-4"}>Dados da Solicitação</h4>
            <Table striped bordered={true}>
              <tbody>
                <tr>
                  <td>Número da Solicitação</td>
                  <td>{validacaoSolicitacao.Numero}</td>
                </tr>
                <tr>
                  <td>Tipo da Solicitação</td>
                  <td>{validacaoSolicitacao.TipoDescricao}</td>
                </tr>
                <tr>
                  <td>Situação</td>
                  <td>{validacaoSolicitacao.SituacaoDescricao}</td>
                </tr>
              </tbody>
            </Table>
          </Card>
          <Card>
            <h4 className={"mb-4"}>Dados da Empresa</h4>
            <Table striped bordered={true}>
              <tbody>
                <tr>
                  <td>CPF/CNPJ</td>
                  <td>{validacaoSolicitacao.CpfCnpjEmpresa}</td>
                </tr>
                <tr>
                  <td>Nome</td>
                  <td>{validacaoSolicitacao.NomeEmpresa}</td>
                </tr>
                <tr>
                  <td>E-mail</td>
                  <td>{validacaoSolicitacao.EmailEmpresa}</td>
                </tr>
              </tbody>
            </Table>
          </Card>
          <Card>
            <h4 className={"mb-4"}>Dados do Contador</h4>
            <Table striped bordered={true}>
              <tbody>
                <tr>
                  <td>CPF/CNPJ</td>
                  <td>{validacaoSolicitacao.CpfCnpjContador}</td>
                </tr>
                <tr>
                  <td>Nome</td>
                  <td>{validacaoSolicitacao.NomeContador}</td>
                </tr>
                <tr>
                  <td>E-mail</td>
                  <td>{validacaoSolicitacao.EmailContador}</td>
                </tr>
              </tbody>
            </Table>
          </Card>
        </Modal.Body>
        <Modal.Footer>
          <small className={"text-left"}>
            Para maiores informações, entre em contato com a Prefeitura.
          </small>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default connect({
  actions: {
    validacaoSolicitacaoActions
  },
  selectors: {
    validacaoSolicitacaoSelector
  }
})(Container);
